<template>
    <div class="container-detail">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку баннеров
            </v-btn>

            <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                Редактировать
            </v-btn>
        </div>

        <div class="detail-main">
            <div class="detail-main-first-container">
                <div class="first-container-box" v-if="banner && banner.event">
                    <div class="container-box-title">
                        Выбранное событие
                    </div>
                    <div class="container-box-text">
                        {{ banner.event.name }}
                    </div>
                </div>
                <div class="first-container-box" v-if="!banner?.isVisibleInNewAppVersion">
                    <div class="container-box-title">
                        Настройки баннера
                    </div>
                    <div class="container-box-text">
                        {{ !banner.isVisibleInNewAppVersion ?  'Отображать только на старых версиях' : ''}}
                    </div>
                    <div class="container-box-text">
                        {{ !banner.isVisibleOnAndroid ?  'Отображать на Android' : ''}}
                    </div>
                    <div class="container-box-text">
                        {{ !banner.isVisibleOnIos ?  'Отображать на IOS' : ''}}
                    </div>
                </div>

                <div class="second-container-box">
                    <div class="container-box-title">
                        Фон баннера
                    </div>
                    <div class="container-box-text">
                        Нажмите на изображение, чтобы увидеть его в полном размере
                    </div>
                </div>

                <div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Формат
                                    </th>
                                    <th class="text-left">
                                        Место отображенния
                                    </th>
                                    <th class="text-left">
                                        Для смартфонов
                                    </th>
                                    <th class="text-left">
                                        Для планшетов
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr style="height: 60px;">
                                    <td class="text-left">Новости и события</td>
                                    <td class="text-left">Выбран режим «Новости и события»</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(banner.additionalSmartphoneImage)"
                                            v-if="banner.additionalSmartphoneImage" class="table-img"
                                            :src="banner.additionalSmartphoneImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(banner.additionalTabletImage)"
                                            v-if="banner.additionalTabletImage" class="table-img"
                                            :src="banner.additionalTabletImage">
                                    </td>
                                </tr>
                                <tr style="height: 60px;">
                                    <td class="text-left">Только события»</td>
                                    <td class="text-left">Выбран режим «Только события»</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(banner.smartphoneImage)" v-if="banner.smartphoneImage"
                                            class="table-img" :src="banner.smartphoneImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(banner.tabletImage)" v-if="banner.tabletImage"
                                            class="table-img" :src="banner.tabletImage">
                                    </td>
                                </tr>



                            </tbody>
                        </template>
                    </v-simple-table>


                    <DialogImage v-model="dialogImg" :src="previewImage" />

                </div>





            </div>



        </div>
    </div>
</template>
<script>

export default {

    data: () => ({
        banner: {},
        dialogImg: false,
        previewImage: '',
        imageWidth: 0,

    }),
    methods: {
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        back() {
            this.$router.push({ name: 'Banners', params: { selectedTicker: 2 } })
        },
        goToEdit() {
            this.$router.push({ name: 'EventsBannerEdit', params: { id: this.$route.params.id } })
        },
        getBanner() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/banner', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    bannerId: this.$route.params.id
                }
            })
                .then(res => {
                    this.banner = res.data

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        }
    },
    created() {
        this.getBanner()
    }
}
</script>
<style lang="scss" scoped>
.container-detail {
    box-sizing: border-box;
    padding: 40px !important;

    .detail-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .detail-main {
        display: flex;
        justify-content: space-between;

        .detail-main-first-container {
            width: 48%;

            .first-container-box {

                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }

                .container-box-text-list {
                    .container-box-text-list-item {
                        display: flex;
                        margin-bottom: 5px;

                        .list-item-subtitle {
                            font-size: 16px;
                            font-weight: 600;
                            color: #929292;
                            width: 200px;
                        }

                        .list-item-text {
                            font-size: 18px;
                            font-weight: 400;
                        }

                    }
                }
            }

            .table-img {
                cursor: pointer;
                height: 38px;
                object-fit: contain;
            }

            .second-container-box {
                width: 100%;
                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }
            }

        }

    }
}
</style>